import React, { useEffect, useRef, useState } from "react";
import { MdArrowDropDown } from "react-icons/md";
import { useSelector } from "react-redux";
import { imgBaseUrl } from "../../utils/constants";
import { IoMdNotificationsOutline } from "react-icons/io";
import NotificationSidebar from "../notifications/NotificationSidebar";

const ProfilePic = ({ onLogout }) => {
  const [showDropDown, setShowDropdown] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const influencerProfile = useSelector(
    (store) => store?.influencer?.influencer?.profilePic
  );
  const influencerName = useSelector(
    (store) => store?.influencer?.influencer?.Name
  );

  const notifyBoxRef = useRef(null);
  const profileBoxRef = useRef(null);

  const showDropdownHandler = () => {
    setShowDropdown((prev) => !prev);
  };

  const showNotificationHandler = () => {
    setShowNotifications((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (notifyBoxRef.current && !notifyBoxRef.current.contains(event.target)) {
      setShowNotifications(false);
    }
    if (
      profileBoxRef.current &&
      !profileBoxRef.current.contains(event.target)
    ) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (showNotifications || showDropDown) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications, showDropDown]);

  return (
    <div className="position-relative d-flex justify-content-between align-items-center">
      {/* <div className="notification_box" onClick={showNotificationHandler}>
        <IoMdNotificationsOutline className="notification_icon" />
        <div className="notify_dot"></div>
      </div>
      {showNotifications && (
        <div className={"dropdown_main position-absolute"} ref={notifyBoxRef}>
          <ul>
            <p>Notifications</p>
            <hr />
            <li className="notification_text">Dummy Notification1</li>
            <li className="mt-2 notification_text">Dummy Notification2</li>
          </ul>
        </div>
      )} */}
      <NotificationSidebar />
      <div className="profile" onClick={showDropdownHandler}>
        {influencerProfile ? (
          <img src={`${imgBaseUrl}/${influencerProfile}`} alt="Profile" />
        ) : (
          <p className="mb-0">
            {influencerName && influencerName[0]?.toUpperCase()}
          </p>
        )}
      </div>
      <MdArrowDropDown className="drop_icon" onClick={showDropdownHandler} />
      {showDropDown && (
        <div className={"dropdown_main position-absolute"} ref={profileBoxRef}>
          <ul>
            {/* <li>
              <NavLink to={"/settings/basic-informations"}>Settings</NavLink>
            </li> */}
            {/* <li className="mt-2">
              <NavLink>Profile</NavLink>
            </li> */}
            {/* <hr /> */}
            <li onClick={onLogout} className="sign_out">
              Sign out
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProfilePic;
